import type { paths } from '@/types/api';
import { fetchClient } from '@/util/fetchClient';

const ENDPOINT = '/v2/inquiries/product-support/eligibility' as const;

type ProductSupportEligibilityPost = paths[typeof ENDPOINT]['post'];

type ProductSupportEligibilityRequest =
  ProductSupportEligibilityPost['requestBody']['content']['application/json'];

type ProductSupportEligibilityResponse =
  ProductSupportEligibilityPost['responses'][200]['content']['application/json'];

export type ProductSupportEligibilitySource = NonNullable<
  ProductSupportEligibilityRequest['source']
>;

export type ProductSupportEligibilityResult = ProductSupportEligibilityResponse['data'];

export async function getProductSupportEligibilityV2(params: {
  cancerFocusId: ProductSupportEligibilityRequest['cancerFocusId'];
  message: ProductSupportEligibilityRequest['message'];
  source: ProductSupportEligibilitySource;
}): Promise<ProductSupportEligibilityResult | null> {
  try {
    const { data } = await fetchClient.POST(ENDPOINT, { body: params });

    if (!data?.success) {
      return null;
    }

    return data.data;
  } catch {
    return null;
  }
}
